import React, { useEffect, useState } from "react";
import Footer from "../../../Kryzen Alpha App/Components//Footer/footer";
import StepRoutes from "../../../Kryzen Alpha App/Routes/steps_routes";
import performRequest from "../../../Kryzen Alpha App/api/request";
import { Toast } from "../../../Kryzen Alpha App/CustomComponent/toast";
import Pagination from "../../../Kryzen Alpha App/Components/layouts/pagination";
import getFilteredURL from "../../../Kryzen Alpha App/Components/Functions/filters.getUrl";
import DynamicFilterInput from "../../Components/layouts/filter.inpit";
import DynamicFilterSelect from "../../Components/layouts/filter.select";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import Applicationtable from "./applicationtable";
import { FcStackOfPhotos } from "react-icons/fc";
import { useSelector } from "react-redux";

const ShowApplications = () => {
  let userData = useSelector((store) => store.login.user);
  const [refresh, setRefresh] = useState(false);
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    jobType: "",
    Etype: "",
    departments: userData?.Role === "client" ? "Agronomist" : "",
    applicationStatus: "",
  });
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);

  useEffect(() => {
    if (userData?.Role == "client") {
      setFilters((prev) => ({
        ...prev,
        departments: "Agronomist",
      }));
      setRefresh((prev) => !prev);
    }
  }, [userData]);

  useEffect(() => {
    performRequest(
      "GET",
      getFilteredURL(`/career/get-applications`, page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res?.data);
          setTotalPages(Math.ceil(res.data?.applicationCount / 50));
        } else {
          Toast("error", "Error while getting applications!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [refresh, page]);

  return (
    <div className="page">
      <div className="page-wrapper">
        <div style={{ minHeight: "80vh" }}>
          <div className="page-header d-print-none">
            <div className="container-xl">
              <div className="row g-2 align-items-center">
                <div className="col">
                  <h2 className="page-title">
                    <FcStackOfPhotos className="fs-2 me-1" />
                    Job Applications
                  </h2>
                  <h4 className="text-muted">
                    <StepRoutes />
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="container-xxl">
              <div className="row">
                <div className="col-md-3 col-sm-12 py-2">
                  <div className="card p-2">
                    <div
                      id="faq-1"
                      className="accordion"
                      role="tablist"
                      aria-multiselectable="true"
                    >
                      <div>
                        <div className="accordion-header m-0" role="tab">
                          <button
                            className="accordion-button fs-3 d-md-none p-0"
                            data-bs-toggle="collapse"
                            data-bs-target="#faq-1-1"
                          >
                            <h3 className="m-1">Filter result</h3>
                          </button>
                        </div>

                        <div
                          id="faq-1-1"
                          className="accordion-collapse collapse d-md-none"
                          role="tabpanel"
                          data-bs-parent="#faq-1"
                        >
                          <div className="accordion-body pt-0">
                            <div className="row">
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Start Date:"
                                  value={filters.startdate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      startdate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="End Date:"
                                  value={filters.enddate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      enddate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Job type:"
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      jobType: e.target.value,
                                    })
                                  }
                                  value={filters.jobType}
                                >
                                  <option value="">select all</option>
                                  <option value="Internship">Internship</option>
                                  <option value="job">Job</option>
                                </DynamicFilterSelect>
                              </div>

                              {userData?.Role !== "client" && (
                                <div className="col-12">
                                  <DynamicFilterSelect
                                    label="Application Status:"
                                    onChange={(e) =>
                                      setFilters({
                                        ...filters,
                                        applicationStatus: e.target.value,
                                      })
                                    }
                                    value={filters.applicationStatus}
                                  >
                                    <option value="">Select All</option>
                                    <option value="viewed">
                                      Profile Visited
                                    </option>
                                    <option value="shortlisted">
                                      Shortlisted
                                    </option>
                                    <option value="pending">Pending</option>
                                  </DynamicFilterSelect>
                                </div>
                              )}

                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Employee type:"
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      Etype: e.target.value,
                                    })
                                  }
                                  value={filters.Etype}
                                >
                                  <option value="">Select</option>
                                  <option value="Fresher">Fresher</option>
                                  <option value="Experience">Experience</option>
                                </DynamicFilterSelect>
                              </div>

                              {userData?.Role !== "client" && (
                                <div className="col-12">
                                  <DynamicFilterSelect
                                    label="Departments:"
                                    onChange={(e) =>
                                      setFilters({
                                        ...filters,
                                        departments: e.target.value,
                                      })
                                    }
                                    value={filters.departments}
                                  >
                                    <option value="">Select</option>
                                    <option value="Business Development">
                                      Business Development (Sales)
                                    </option>
                                    <option value="Operations Executive">
                                      Operations Executive (Purchase)
                                    </option>
                                    <option value="Social Media Marketing">
                                      Social Media Marketing (Video Editing,
                                      Graphic Design)
                                    </option>
                                    <option value="Human Resources">
                                      Human Resources
                                    </option>
                                    <option value="Accounting">
                                      Accounting
                                    </option>
                                    <option value="Management">
                                      Management
                                    </option>
                                    <option value="Agronomist">
                                      Agronomist
                                    </option>
                                  </DynamicFilterSelect>
                                </div>
                              )}

                              <div className="col-12">
                                <div className="row mt-2">
                                  <div className="col-6">
                                    <button
                                      onClick={() => setRefresh(!refresh)}
                                      className="btn btn-success w-100"
                                    >
                                      Apply Filter
                                    </button>
                                  </div>
                                  <div className="col-6">
                                    <button
                                      onClick={() => {
                                        setFilters({
                                          startdate: "",
                                          enddate: "",
                                          jobType: "",
                                          Etype: "",
                                          departments: "",
                                        });
                                        setRefresh(!refresh);
                                      }}
                                      className="btn btn-secondary w-100"
                                    >
                                      Reset Filter
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="accordion-body d-none d-md-block">
                          <div className="row">
                            <h3>Filter result</h3>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Start Date:"
                                value={filters.startdate}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    startdate: e.target.value,
                                  })
                                }
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="End Date:"
                                value={filters.enddate}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    enddate: e.target.value,
                                  })
                                }
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Job type:"
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    jobType: e.target.value,
                                  })
                                }
                                value={filters.jobType}
                              >
                                <option value="">select all</option>
                                <option value="Internship">Internship</option>
                                <option value="job">Job</option>
                              </DynamicFilterSelect>
                            </div>

                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Employee type:"
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    Etype: e.target.value,
                                  })
                                }
                                value={filters.Etype}
                              >
                                <option value="">Select</option>
                                <option value="Fresher">Fresher</option>
                                <option value="Experience">Experience</option>
                              </DynamicFilterSelect>
                            </div>
                            {userData?.Role !== "client" && (
                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Departments:"
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      departments: e.target.value,
                                    })
                                  }
                                  value={filters.departments}
                                >
                                  <option value="">Select</option>
                                  <option value="Business Development">
                                    Business Development (Sales)
                                  </option>
                                  <option value="Operations Executive">
                                    Operations Executive (Purchase)
                                  </option>
                                  <option value="Social Media Marketing">
                                    Social Media Marketing (Video Editing,
                                    Graphic Design)
                                  </option>
                                  <option value="Human Resources">
                                    Human Resources
                                  </option>
                                  <option value="Accounting">Accounting</option>
                                  <option value="Management">Management</option>
                                  <option value="Agronomist">Agronomist</option>
                                </DynamicFilterSelect>
                              </div>
                            )}

                            {userData?.Role !== "client" && (
                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Application Status:"
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      applicationStatus: e.target.value,
                                    })
                                  }
                                  value={filters.applicationStatus}
                                >
                                  <option value="">Select All</option>
                                  <option value="viewed">
                                    Profile Visited
                                  </option>
                                  <option value="shortlisted">
                                    Shortlisted
                                  </option>
                                  <option value="pending">Pending</option>
                                </DynamicFilterSelect>
                              </div>
                            )}

                            <div className="col-12">
                              <div className="row mt-2">
                                <div className="col-6">
                                  <button
                                    onClick={() => setRefresh(!refresh)}
                                    className="btn btn-success w-100"
                                  >
                                    Apply Filter
                                  </button>
                                </div>
                                <div className="col-6">
                                  <button
                                    onClick={() => {
                                      setFilters({
                                        startdate: "",
                                        enddate: "",
                                        jobType: "",
                                        Etype: "",
                                        departments: "",
                                      });
                                      setRefresh(!refresh);
                                    }}
                                    className="btn btn-secondary w-100"
                                  >
                                    Reset Filter
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-9 col-sm-12 py-2">
                  <div className="card">
                    <Applicationtable
                      data={data?.application}
                      currentPage={page}
                      itemsPerPage={50}
                      userRole={userData?.Role}
                    />
                    <Pagination
                      page={page}
                      setPage={setPage}
                      totalPages={totalPages}
                      pageDatalength={data?.length}
                      showPage={showPage}
                      setShowPage={setShowPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ShowApplications;